(function ($) {

    const ajaxUrl = spraga_obj.ajax_url;
    const nonce = spraga_obj.reviews.nonce;
    const defaultPid = String((spraga_obj.reviews && spraga_obj.reviews.product_id) || '');

    const SHOW_CLASS = 'spraga-reviews-modal-trigger-show';

    // Cache
    const cache = {};

    function ensureCache(pid) {
        if (!cache[pid]) cache[pid] = { reviews: {}, form: null, preloaded: false };
        return cache[pid];
    }

    function getPidFrom(el) {
        const byBtn = $(el).data('product-id');
        const byWrap = $(el).closest('[data-spraga-product-reviews]').data('product-id');
        const byFooter = $('[data-spraga-product-reviews-modals]').first().data('product-id');

        const pid = defaultPid || String(byBtn || byWrap || byFooter || '');
        return pid;
    }

    function $reviewsModal(pid) {
        return $('#spraga-reviews-modal-' + pid);
    }

    function $formModal(pid) {
        return $('#spraga-review-form-modal-' + pid);
    }

    function openModal($modal, pid) {


        // close both first
        closeModal($reviewsModal(pid));
        closeModal($formModal(pid));

        $modal.addClass(SHOW_CLASS).attr('aria-hidden', 'false');
        $('html').addClass('has-off-canvas');
        $('body').addClass('spraga-modal-open');


    }

    function closeModal($modal) {
        if (!$modal || !$modal.length) return;

        $modal.removeClass(SHOW_CLASS).attr('aria-hidden', 'true');

        if (!$('.spraga-modal.' + SHOW_CLASS).length) {
            $('html').removeClass('has-off-canvas');
            $('body').removeClass('spraga-modal-open');
        }
    }

    function renderReviewsHtml(pid, html, page) {
        const $modal = $reviewsModal(pid);
        const $content = $modal.find('[data-spraga-reviews-content]');

        $content.html(html);
        $modal.data('page', page);
    }

    function renderFormHtml(pid, html) {
        const $modal = $formModal(pid);
        const $content = $modal.find('[data-spraga-review-form-content]');
        $content.html(html);
    }

    function getFilterData(pid) {
        const $m = $reviewsModal(pid);
        const data = {};

        // Sorting
        const sort = $m.find('input[name="sort_by"]:checked').val();
        if (sort) data.sort_by = sort;

        // Rating filters
        const ratings = [];
        $m.find('input[name="rating_filter[]"]:checked').each(function () {
            ratings.push($(this).val());
        });
        if (ratings.length > 0) data.rating = ratings;

        // Language filter
        const lang = $m.find('input[name="language_filter"]:checked').val();
        if (lang) data.language = [lang];

        return data;
    }

    function loadReviews(pid, page = 1, opts = {}) {
        const c = ensureCache(pid);
        const silent = !!opts.silent;
        const force = !!opts.force;

        const filterData = getFilterData(pid);
        // Serialize filter data for cache key
        const cacheKey = page + '_' + JSON.stringify(filterData);



        if (!force && c.reviews[cacheKey] && !opts.append) {
            renderReviewsHtml(pid, c.reviews[cacheKey], page);
            return $.Deferred().resolve().promise();
        }

        if (!silent && !opts.append) {
            $reviewsModal(pid).find('.spraga-reviews-main').css({ opacity: 0.5, pointerEvents: 'none' });
        }

        if (opts.append) {
            c.isLoadingNext = true;
            $reviewsModal(pid).find('.spraga-reviews-infinite-loader').show();
        }

        const requestData = {
            action: 'spraga_get_product_reviews',
            nonce,
            product_id: pid,
            cpage: page
        };
        $.extend(requestData, filterData);

        return $.post(ajaxUrl, requestData).done((res) => {

            if (res && res.success && res.data && res.data.html) {
                if (opts.append) {
                    const $parsed = $('<div>').html(res.data.html);
                    const newItems = $parsed.find('.commentlist').html();
                    if (newItems && newItems.trim()) {
                        $reviewsModal(pid).find('.commentlist').append(newItems);
                    }
                    $reviewsModal(pid).find('.spraga-reviews-infinite-loader').hide();
                    $reviewsModal(pid).data('page', page);
                    c.isLoadingNext = false;
                } else {
                    c.reviews[cacheKey] = res.data.html;
                    renderReviewsHtml(pid, res.data.html, page);
                }
            } else if (!silent) {
                if (opts.append) {
                    $reviewsModal(pid).find('.spraga-reviews-infinite-loader').hide();
                    c.isLoadingNext = false;
                } else {
                    const errorMsg = (SPRAGA_I18N && SPRAGA_I18N.failed_to_load_reviews) || 'Failed to load reviews.';
                    renderReviewsHtml(pid, `<div class="spraga-error">${errorMsg}</div>`, page);
                }
            }
        }).fail((xhr) => {
            console.error('loadReviews() fail', xhr && xhr.status, xhr && xhr.responseText);
            if (opts.append) {
                $reviewsModal(pid).find('.spraga-reviews-infinite-loader').hide();
                c.isLoadingNext = false;
            } else if (!silent) {
                const errorMsg = (SPRAGA_I18N && SPRAGA_I18N.failed_to_load_reviews) || 'Failed to load reviews.';
                renderReviewsHtml(pid, `<div class="spraga-error">${errorMsg}</div>`, page);
            }
        });
    }

    function loadReviewForm(pid, opts = {}) {
        const c = ensureCache(pid);
        const silent = !!opts.silent;



        if (c.form) {
            renderFormHtml(pid, c.form);
            return $.Deferred().resolve().promise();
        }

        if (!silent) {
            $formModal(pid).find('.spraga-modal-body').css({ opacity: 0.5, pointerEvents: 'none' });
        }

        return $.post(ajaxUrl, {
            action: 'spraga_get_review_form',
            nonce,
            product_id: pid
        }).done((res) => {


            if (res && res.success && res.data) {
                if (res.data.redirect) {
                    // Redirect for non-logged in users
                    window.location.href = res.data.redirect;
                    return;
                }
                if (res.data.html) {
                    c.form = res.data.html;
                    renderFormHtml(pid, res.data.html);

                    // Set browser language in the hidden field
                    const langInput = $formModal(pid).find('#spraga_browser_lang');
                    if (langInput.length) {
                        langInput.val(navigator.language || navigator.userLanguage || '');
                    }
                }
            } else if (!silent) {
                const errorMsg = (SPRAGA_I18N && SPRAGA_I18N.failed_to_load_form) || 'Failed to load form.';
                renderFormHtml(pid, `<div class="spraga-error">${errorMsg}</div>`);
            }
        }).fail((xhr) => {
            derr('loadReviewForm() fail', xhr && xhr.status, xhr && xhr.responseText);
            if (!silent) {
                const errorMsg = (SPRAGA_I18N && SPRAGA_I18N.failed_to_load_form) || 'Failed to load form.';
                renderFormHtml(pid, `<div class="spraga-error">${errorMsg}</div>`);
            }
        });
    }

    function preloadOnce(pid) {
        if (!pid) return;
        const c = ensureCache(pid);
        if (c.preloaded) return;
        c.preloaded = true;

        $.when(
            loadReviews(pid, 1, { silent: true })
        );
    }

    // Preload on ready
    $(function () {
        if (defaultPid) {
            const c = ensureCache(defaultPid);
            const $m = $reviewsModal(defaultPid);
            if ($m.length) {
                const initialHtml = $m.find('[data-spraga-reviews-content]').html();
                if (initialHtml && initialHtml.trim()) {
                    const filterData = getFilterData(defaultPid);
                    const cacheKey = '1_' + JSON.stringify(filterData);
                    c.reviews[cacheKey] = initialHtml;
                }
            }
        }
        preloadOnce(defaultPid);
    });

    // ---- events ----
    $(document).on('click', '[data-spraga-open-reviews]', function (e) {

        e.preventDefault();

        const pid = getPidFrom(this);
        if (!pid) {

            return;
        }

        const $m = $reviewsModal(pid);


        openModal($m, pid);

        // This will instantly resolve from the cache we primed above
        loadReviews(pid, 1);
    });

    // Smooth scroll for "Buy to leave a review" button
    $(document).on('click', '.spraga-scroll-to-buy', function (e) {
        e.preventDefault();
        const target = $(this).data('target');
        const $target = $(target);

        if ($target.length) {
            $('html, body').animate({
                scrollTop: $target.offset().top - 300 // offset for header
            }, 800);
        }
    });

    $(document).on('click', '[data-spraga-open-review-form]', function (e) {

        e.preventDefault();

        const pid = getPidFrom(this);
        if (!pid) return;

        closeModal($reviewsModal(pid));
        openModal($formModal(pid), pid);

        const langInput = $formModal(pid).find('#spraga_browser_lang');
        if (langInput.length && !langInput.val()) {
            langInput.val(navigator.language || navigator.userLanguage || '');
        }
    });

    $(document).on('click', '[data-spraga-back-to-reviews]', function (e) {

        e.preventDefault();

        const pid = defaultPid || String($('[data-spraga-product-reviews-modals]').data('product-id') || '');
        if (!pid) return;

        const page = parseInt($reviewsModal(pid).data('page'), 10) || 1;

        closeModal($formModal(pid));
        openModal($reviewsModal(pid), pid);

        const c = ensureCache(pid);
        if (c.reviews[page]) renderReviewsHtml(pid, c.reviews[page], page);
        else loadReviews(pid, page);
    });

    $(document).on('click', '[data-spraga-close]', function (e) {

        e.preventDefault();

        const pid = defaultPid || String($('[data-spraga-product-reviews-modals]').data('product-id') || '');
        closeModal($reviewsModal(pid));
        closeModal($formModal(pid));
    });

    $(document).on('keydown', function (e) {
        if (e.key !== 'Escape') return;


        const pid = defaultPid || String($('[data-spraga-product-reviews-modals]').data('product-id') || '');
        closeModal($reviewsModal(pid));
        closeModal($formModal(pid));
    });

    $(document).on('click', '.spraga-modal', function (e) {
        if ($(e.target).hasClass('spraga-modal')) {
            const pid = defaultPid || String($('[data-spraga-product-reviews-modals]').data('product-id') || '');
            closeModal($reviewsModal(pid));
            closeModal($formModal(pid));
        }
    });

    // ---- Filter & Sort Events ----
    $(document).on('click', '[data-spraga-toggle]', function (e) {
        e.preventDefault();
        const $wrap = $(this).parent();
        const $dropdown = $wrap.find('.spraga-dropdown');
        const wasHidden = $dropdown.attr('hidden');

        // Close others
        $('.spraga-dropdown').not($dropdown).attr('hidden', 'hidden');
        $('[data-spraga-toggle]').removeClass('active');

        if (wasHidden) {
            $dropdown.removeAttr('hidden');
            $(this).addClass('active');
        } else {
            $dropdown.attr('hidden', 'hidden');
            $(this).removeClass('active');
        }
    });

    // Accordion inside filter dropdown
    $(document).on('click', '.spraga-filter-accordion-btn', function (e) {
        e.preventDefault();
        e.stopPropagation(); // Prevent closing dropdown
        const $section = $(this).closest('.spraga-accordion-section');
        const $content = $section.find('.spraga-filter-accordion-content');

        $section.toggleClass('is-open');
        $content.slideToggle(200);
    });

    // Close dropdowns when clicking outside
    $(document).on('click', function (e) {
        if (!$(e.target).closest('.spraga-reviews-toolbar').length) {
            $('.spraga-dropdown').attr('hidden', 'hidden');
            $('[data-spraga-toggle]').removeClass('active');
        }
    });

    // Custom Star Rating Interaction for the Review Form
    $(document).on('mouseenter', '.spraga-star-empty', function () {
        const rating = parseInt($(this).data('rating'), 10);
        const $wrap = $(this).closest('.spraga-stars-select');

        $wrap.find('.spraga-star-empty').each(function () {
            if (parseInt($(this).data('rating'), 10) <= rating) {
                $(this).addClass('is-hover');
            } else {
                $(this).removeClass('is-hover');
            }
        });
    });

    $(document).on('mouseleave', '.spraga-stars-select', function () {
        $(this).find('.spraga-star-empty').removeClass('is-hover');
    });

    $(document).on('click', '.spraga-star-empty', function () {
        const rating = parseInt($(this).data('rating'), 10);
        const $wrap = $(this).closest('.spraga-stars-select');
        const $select = $wrap.siblings('#spraga_rating'); // Find hidden select

        // Update hidden select
        if ($select.length) {
            $select.val(rating);
        }

        // Update visual state
        $wrap.find('.spraga-star-empty').each(function () {
            if (parseInt($(this).data('rating'), 10) <= rating) {
                $(this).addClass('is-active');
            } else {
                $(this).removeClass('is-active');
            }
        });
    });

    // Form validation before submit
    $(document).on('submit', '#commentform', function (e) {
        const $form = $(this);
        const $ratingSelect = $form.find('#spraga_rating');
        const $textarea = $form.find('#comment');
        let isValid = true;

        $form.find('.woocommerce-error').remove(); // clear previous errors
        $form.find('.has-error').removeClass('has-error');

        // Validate rating
        if ($ratingSelect.length && !$ratingSelect.val()) {
            e.preventDefault();
            const errorMsg = (SPRAGA_I18N && SPRAGA_I18N.please_select_rating) || 'Please select a rating.';
            $form.find('.spraga-stars-select').after(`<div class="woocommerce-error" role="alert" style="margin-top:15px; margin-bottom:0;"><li style="list-style: none"><div class="message-container alert-color">${errorMsg}</div></li></div>`);
            isValid = false;
        }

        // Validate textarea
        if ($textarea.length && !$textarea.val().trim()) {
            e.preventDefault();
            $textarea.addClass('has-error');
            const errorMsg = (SPRAGA_I18N && SPRAGA_I18N.please_write_review) || 'Please write your detailed review.';
            $textarea.after(`<div class="woocommerce-error" role="alert" style="margin-top:15px; margin-bottom:0;"><li style="list-style: none"><div class="message-container alert-color">${errorMsg}</div></li></div>`);
            isValid = false;
        }

        if (!isValid) {
            return false;
        }
    });

    // Trigger reload on filter/sort change
    $(document).on('change', '.spraga-reviews-toolbar input', function () {
        const pid = getPidFrom(this);
        if (!pid) return;

        // Force reload reviews to apply new filters
        loadReviews(pid, 1, { force: true });
    });

    // Infinite scroll for reviews list
    document.addEventListener('scroll', function (e) {
        if (!e.target || !e.target.classList || !e.target.classList.contains('spraga-reviews-list')) return;

        const $list = $(e.target);
        const pid = getPidFrom(e.target) || defaultPid;
        if (!pid) return;

        const c = ensureCache(pid);

        // Ensure we don't fire multiple requests
        if (c.isLoadingNext) return;

        const totalPages = parseInt($list.attr('data-total-pages'), 10) || 1;
        const currentPage = parseInt($reviewsModal(pid).data('page'), 10) || 1;

        if (currentPage >= totalPages) return; // reached the end

        // Calculate if we're near the bottom
        const scrollTop = $list.scrollTop();
        const innerHeight = $list.innerHeight();
        const scrollHeight = $list[0].scrollHeight;

        if (scrollTop + innerHeight >= scrollHeight - 50) {
            loadReviews(pid, currentPage + 1, { append: true });
        }
    }, true);

})(jQuery);
